var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysPersonalInformation = function SvgSysPersonalInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.645 11.132c.41-.488.936-.865 1.53-1.095Zm1.53-1.095A7.854 7.854 0 0 1 8.14 9.54h.017a7.882 7.882 0 0 1 2.963.497c.594.23 1.12.607 1.53 1.095.382.454.608 1.017.646 1.608a.843.843 0 0 1-.84.831H3.839a.843.843 0 0 1-.839-.83c.039-.591.265-1.155.645-1.609m4.503-2.259a8.521 8.521 0 0 0-3.208.54l-.004.002c-.7.27-1.319.714-1.801 1.289a3.45 3.45 0 0 0-.801 2.007V12.732a1.51 1.51 0 0 0 1.504 1.506H12.458a1.51 1.51 0 0 0 1.504-1.506v-.02a3.441 3.441 0 0 0-.801-2.008 4.453 4.453 0 0 0-1.802-1.29h-.003a8.548 8.548 0 0 0-3.207-.54ZM8.337 2.333a2.619 2.619 0 1 0 0 5.238 2.619 2.619 0 0 0 0-5.238ZM5.05 4.952a3.285 3.285 0 1 1 6.571 0 3.285 3.285 0 0 1-6.57 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysPersonalInformation;